/**
 * Capture the beforeinstallprompt event so we can show a custom install button.
 */

import { useEffect } from 'react';
import { useAppStore, type BeforeInstallPromptEvent } from '../store/app';

export function useInstallPrompt(): void {
  const setInstallPrompt = useAppStore((s) => s.setInstallPrompt);

  useEffect(() => {
    const handler = (e: Event) => {
      e.preventDefault();
      setInstallPrompt(e as BeforeInstallPromptEvent);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, [setInstallPrompt]);
}
